import isEmpty from "lodash/isEmpty";
import { retriveFromSession } from "@/utils/session";

export const reorderParticipatingUniversities = (universityList, resUniversityList) => {
    return universityList.map((item) => {
        const filteredUniversity = resUniversityList.filter(
            (resUniversity) => resUniversity.university_code === item.university_code
        );
        if (filteredUniversity.length) return filteredUniversity[0];
    });
};

export const updateParticipatingUniversitiesInStudent = (
    students,
    registrantCode,
    participatingUniversities
) => {
    if (isEmpty(students)) return [];

    return students.map((student) => {
        if (student.registrantCode === registrantCode) {
            return { ...student, participatingUniversities };
        }

        return student;
    });
};

export const getMustVisitPayload = (universities, registrantCode, toggleMustVisit = true) => {
    const universityList = universities.filter((university) => university.university_code),
        fair_id = retriveFromSession("fairID");

    if (!registrantCode || !fair_id || isEmpty(universityList)) {
        return null;
    }

    return {
        fair_id,
        registrant_code: registrantCode,
        data: universityList.map((university) => ({
            university_code: university.university_code,
            must_visit: toggleMustVisit
                ? !university.must_visit
                : university.must_visit,
        })),
    };
};
